export type FiscalYearOptionTestId =
  | typeof FISCAL_YEAR_SELECT_TEST_ID.LAST_YEAR
  | typeof FISCAL_YEAR_SELECT_TEST_ID.CURRENT_YEAR;

export const FISCAL_YEAR_SELECT_TEST_ID = {
  SELECT: 'fiscal-year-select',
  LAST_YEAR: 'fiscal-year-select-last-year',
  CURRENT_YEAR: 'fiscal-year-select-current-year',
} as const;
